import ceFouncation from '@/Uketsuke/custom/CEFoundationApp.vue';
import ceFoundationMenu from '@/Uketsuke/custom/templates/CEFoundationMenu.vue';
import traderInfoSearch from '@/Uketsuke/custom/templates/TraderInfoSearch.vue';
import traderInfo from '@/Uketsuke/custom/templates/TraderInfo.vue';
import traderInfoKanri from '@/Uketsuke/custom/templates/TraderInfoKanri.vue';

export default {
  path: '/ce-foundation',
  component: ceFouncation,
  children: [
    {
      path: '/',
      name: 'ceFoundationMenu',
      component: ceFoundationMenu,
    },
    {
      path: '/traderInfoSearch',
      name: 'traderInfoSearch',
      component: traderInfoSearch,
    },
    {
      path: '/traderInfo',
      name: 'traderInfo',
      component: traderInfo,
    },
    {
      path: '/traderInfoKanri',
      name: 'traderInfoKanri',
      component: traderInfoKanri,
    },
  ],
};
